import React from 'react'
import ReactMarkdown from 'react-markdown'

const Richtext = ({ text, flow, className = '' }) => {
  return (
    <>
      {text && (
        <ReactMarkdown
          children={text}
          className={`richtext ${className} ${
            flow === 'true' ? 'two-col-flow' : ''
          }`}
        />
      )}
    </>
  )
}

export default Richtext
